<template>
    <div class="col-md-5">
        <div class="position-fixed">
            <h2>{{ trans.get('checkout.order_summary') }}</h2>
            <div v-for="item in cartContent" @mouseover="mouseOver(item)" @mouseout="mouseOut(item)">
                <div class="row">
                    <div class="col-9">{{ item.name}}</div>
                    <div class="col-3 text-right">
                        <strong>{{ (item.price * item.qty) | priceFormat() | withCurrency(currency) }}</strong>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">{{ trans.get('checkout.quantity') }}: {{ item.qty}}</div>
                    <div class="col-6 text-right">
                        <button v-show="item === getActiveItem" @click="removeItem(item)" type="button" class="close"
                                aria-label="Close">
                            <span class="remove-btn" aria-hidden="true">{{ trans.get('checkout.remove') }} &times;</span>
                        </button>
                    </div>
                </div>
            </div>
            <hr class="border-top"/>
            <div class="row mt-2">
                <div class="col-6">{{ trans.get('checkout.subtotal') }}</div>
                <div class="col-6 text-right">
                    {{ subTotal | priceFormat() | withCurrency(currency) }}
                </div>
            </div>
            <div v-if="deliveryTotal" class="row mt-2">
                <div class="col-6">{{ trans.get('checkout.delivery') }}</div>
                <div class="col-6 text-right">
                    {{ deliveryTotal | priceFormat() | withCurrency(currency) }}
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-6"><strong>{{ trans.get('checkout.total') }}</strong></div>
                <div class="col-6 text-right">
                    <strong>{{ cartTotal | priceFormat() | withCurrency(currency) }}</strong>
                </div>
            </div>
            <error-messages></error-messages>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vuex-map-fields';
    import ErrorMessages from './ErrorMessages';

    export default {
        name:     'order-summary',
        components: {
            ErrorMessages
        },
        props:    {},
        data() {
            return {
                activeItem : null
            };
        },
        methods:  {
            removeItem(item) {
                if (this.loading) {
                    return
                }
                var self = this;
                axios.delete(window.remove_from_cart, {params: {cart_item_row_id: item.rowId}})
                    .then(function (response) {
                        self.cartContent = response.data.cartContent;
                        self.subTotal  = parseFloat(response.data.cartTotal.replace(',',''));
                        self.ticketCategories = response.data.ticketCategories;
                        let delivery_method_ids = {};
                        for (let ticketCategoryId in self.delivery_method_id) {
                            for (let index in self.ticketCategories) {
                                if (ticketCategoryId == self.ticketCategories[index].id) {
                                    delivery_method_ids[ticketCategoryId] = self.delivery_method_id[ticketCategoryId]
                                }
                            }
                        }
                        self.delivery_method_id = delivery_method_ids
                        if (!self.ticketCategories.length) {
                            window.location.href = response.data.empty_cart_redirect;
                        }
                    })
            },
            mouseOver: function (item) {
                this.activeItem = item;
            },
            mouseOut:  function (item) {
                this.activeItem = null;
            },
        },
        computed: {
            ...mapFields([
                'cartTotal',
                'subTotal',
                'deliveryTotal',
                'ticketCategories',
                'currency',
                'cartContent',
                'loading',
                'order.delivery_method_id',
            ]),
            isValid() {
                return true;
            },
            getActiveItem() {
                return this.activeItem;
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .remove-btn {
        font-size: 13px;
    }
</style>
